import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import { FormFirstStep } from "./firstStepForm";
import { StepButton } from "./stepButton";
import { classVoiceSchema } from "./voiceAddSchema";
import { store } from "../../redux/storeConfig/store";
import {
  createClass,
  getAllMembers,
  getTrainer,
  getTrainers,
} from "../../redux/actions/api/apiAction";
import {
  checkIfTimesWithenTrainerSchedule,
  getClassDatesObject,
} from "./utils";
import { toastr } from "react-redux-toastr";
import moment from "moment";
import { useSelector } from "react-redux";
import { DateHelper } from "../../helper/helpers";
import _ from "lodash";
import { ForceAddModal } from "./forcaAddModel";
import { setForceAddModalOpen } from "../../redux/actions/class/classAction";
import SpinnerComponent from "../spinner/spinner";
import { saveVoiceDraftEdit } from "../voiceAdd/saveDraftEdit";
import { withVoicePrefill } from "../voiceAdd/openForm";

const renderStep = (step, values, errors, touched, setFieldValue) => {
  return (
    <FormFirstStep
      errors={errors}
      touched={touched}
      values={values}
      setFieldValue={setFieldValue}
    />
  );
};

function MultiStepForClass({
  handleSubmit,
  waitingList,
  addPrivate,
  edit,
  showTrainer,
  trainer,
  startDate,
  endDate,
  name,
  capacity,
  day,
  to,
  from,
  type,
  tax,
  waitingListRule,
  waitingListCapacity,
  bookingWindowStart,
  bookingWindowEnd,
  bookingStartUnit,
  bookingEndUnit,
  cancelBefore,
  timesArray,
}) {
  const [step, setStep] = useState(1);
  const [canSubmit, setCanSubmit] = useState(false);

  const { forceAddModalOpen } = useSelector((state) => state.class);
  const { loading } = useSelector((state) => state.gym);
  const voicePrefill = useSelector(
    (state) => state.voiceAdd && state.voiceAdd.prefill
  );
  const voiceFields =
    voicePrefill && voicePrefill.type === "class"
      ? voicePrefill.fields || {}
      : {};

  useEffect(() => {
    store.dispatch(
      getAllMembers(
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym
      )
    );
    store.dispatch(
      getTrainers(
        1,
        1000,
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym
      )
    );
  }, []);

  const { trainer: selectedTrainer } = useSelector((state) => state.trainer);

  const toDateValue = (value) => {
    if (value instanceof Date && !Number.isNaN(value.getTime())) return value;
    if (typeof value === "number" && Number.isFinite(value)) return new Date(value);
    const parsed = value ? new Date(value) : null;
    return parsed && !Number.isNaN(parsed.getTime()) ? parsed : null;
  };

  const submit = async (values) => {
    if (saveVoiceDraftEdit(values)) return;
    let {
      bookingWindowEnd,
      bookingWindowStart,
      startDate,
      endDate,
      classDates,
      bookingStartUnit,
      bookingEndUnit,
      cancelBefore,
      cancelationWindowUnit,
      timesArray,
      payRates,
    } = values;

    const safeTimes = Array.isArray(timesArray) ? timesArray : [];
    const safeDates = Array.isArray(classDates) ? classDates : [];
    const start = toDateValue(startDate);
    const finish = toDateValue(endDate);
    if (!start || !finish) {
      toastr.error("Class start and end dates are required");
      return;
    }

    const { scheduleDays } = selectedTrainer || {};

    let openForceAddModal;

    let datesObj = {};

    const classDays = safeDates.map((date) => {
      let dayString = DateHelper.GetFullDayString(parseInt(date));
      let arr = [];
      for (let i = 0; i < safeTimes.length; i++) {
        const element = safeTimes[i] || {};
        arr.push({
          start: element.from,
          end: element.to,
        });
      }
      datesObj[dayString] = arr;
      arr = [];
      return dayString;
    });

    openForceAddModal = !checkIfTimesWithenTrainerSchedule(
      classDays,
      scheduleDays,
      datesObj
    );

    if (openForceAddModal) {
      store.dispatch(setForceAddModalOpen(true));
    }

    const datesToSend = [start, finish].map((item) => item.getTime());

    let timeForDates = [];
    safeDates.forEach((date) => {
      let dateString = moment(date).format("DD/MM/yyyy");
      for (let index = 0; index < safeTimes.length; index++) {
        const element = safeTimes[index] || {};
        timeForDates.push({
          from: parseInt(
            moment(dateString + " " + element.from, "DD/MM/yyyyLT").format("x")
          ),
          to: parseInt(
            moment(dateString + " " + element.to, "DD/MM/yyyyLT").format("x")
          ),
        });
      }
    });
    try {
      let datesWithBookings = getClassDatesObject(
        bookingWindowStart,
        bookingWindowEnd,
        timeForDates,
        bookingStartUnit,
        bookingEndUnit,
        cancelBefore,
        cancelationWindowUnit
      );

      let req = _.cloneDeep(values);
      req.classDates = datesWithBookings;
      req.startDate = datesToSend[0];
      req.endDate = datesToSend[1];
      req.timesArray = safeTimes;
      req.assignedPackages = Array.isArray(req.assignedPackages)
        ? req.assignedPackages
        : [];

      req.assignedPackages.forEach((pack) => {
        if (!parseInt(pack.count)) {
          if (!pack?.allowTransfereBookings) {
            pack.count = pack.sessionCount;
          } else {
            pack.count = 0;
          }
        }
      });
      req.payrateId =
        req?.payRates && req?.payRates.length && req?.payRates[0]?.id;
      if (!openForceAddModal) store.dispatch(createClass(req));
    } catch (e) {
      toastr.error(e.message);
    }
  };

  const previous = () => setStep((step) => step - 1);

  const formSchema1 = classVoiceSchema;

  let autoCreateSinglePackage = false;

  if (loading)
    return (
      <div
        style={{ height: "800px" }}
        className="d-flex flex-column align-items-center justify-content-center"
      >
        <SpinnerComponent />
        <h3>Please wait</h3>
      </div>
    );
  return (
    <>
      <Formik
        enableReinitialize
        initialValues={withVoicePrefill("class", {
          edit,
          payRates: null,
          waitingList: false,
          freeTrial: false,
          trainer: trainer,
          showTrainer,
          startDate,
          endDate,
          name,
          capacity,
          day,
          to,
          from,
          type,
          tax,
          waitingListRule,
          waitingListCapacity,
          autoCreateSinglePackage,
          allowCancelation: false,
          allowUnpaidBooking: false,
          noShowDeduction: false,
          classDates: [],
          bookingWindowEnd,
          bookingWindowStart,
          bookingStartUnit: "d",
          bookingEndUnit: "d",
          cancelationWindowUnit: "h",
          cancelBefore,
          timesArray: [],
          gender: "",
          disableOnlineBooking: false,
          description: "",
          court: null,
          isPublished:true,
          ...voiceFields,
        })}
        onSubmit={submit}
        validationSchema={formSchema1}
      >
        {({ errors, touched, values, setFieldValue }) => (
          <>
            <Form>
              {renderStep(step, values, errors, touched, setFieldValue)}
              <StepButton
                step={step}
                previous={previous}
                edit={edit}
                addPrivate={addPrivate}
              />
            </Form>
            <ForceAddModal values={values} />
          </>
        )}
      </Formik>
    </>
  );
}
MultiStepForClass.defaultProps = {
  members: [],
  startDate: new Date(),
  endDate: new Date(),
  handleSubmit: (values) => {
    //console.log(values, "values here");
  },
  addPrivate: () => {},
  edit: false,
  trainer: "",
  showTrainer: true,
  waitingList: false,
  waitingListRule: "auto",
  freeTrial: false,
  autoCreateSinglePackage: true,
  isPublished:true
};

export default MultiStepForClass;
